import { buildRoutePath } from '@/utils/routes';

export type SettingsTab = 'account' | 'program' | 'organization' | 'developer';

const SETTINGS_TABS: readonly SettingsTab[] = ['account', 'program', 'organization', 'developer'];

/** The tab named by `?tab=`; anything unknown opens Account. */
export function parseSettingsTab(value: string | null | undefined): SettingsTab {
  return SETTINGS_TABS.find(tab => tab === value) ?? 'account';
}

/** Settings for an org and program, opened on `tab` (Account when omitted). */
export function settingsPath(organizationId: string, programId: string, tab?: SettingsTab): string {
  const path = buildRoutePath('/settings', organizationId, programId);
  return tab && tab !== 'account' ? `${path}?tab=${tab}` : path;
}
